import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import {FormattedDate, FormattedTime} from 'react-intl';
import ShowOptionalField from '../ShowOptionalField'
import ShowOptionalLabel from '../ShowOptionalLabel'
import ModalConfirm from '../ModalConfirm'
import {copiaTestoNegliAppunti, getShortText} from "../../Helpers";
import {client} from '../../Client';
import LocalDate from "../LocalDate";
import LocalTime from "../LocalTime";
import SiNoTableColumn from "../SiNoTableColumn";

class UtentiTableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    onCopyToClipboard(value){
        copiaTestoNegliAppunti(value);
    }

    render() {
        let c = this.props.utente;

        let editBtn = null;
        if (this.props.readOnly == false){
            editBtn =(
                <Link  className="ui blue icon button" to={`/app/utenti/edit/${c.idUtente}`}>
                    <i
                        className="edit icon"

                    ></i>
                </Link>
            );
        }

        let deleteButton = null;
        if (this.props.readOnly == false && client.getCurrentUser().isadmin) {
            deleteButton = (<ModalConfirm
                msg={"Stai per cancellare l'utente: " + c.username + "."}
                msgDescription={(<h3>Verrà <span>cancellato</span> l'utente indicato.</h3>)}
                onClickOk={(ev) => (this.props.onDeleteItem(ev, c))}
            >
                <a className="ui red icon button"><i className="trash icon"/></a>
            </ModalConfirm>);
        }
        let lnkUsername = (<strong>{c.titolo}</strong>);
        if (this.props.readOnly == false){
            lnkUsername = <Link to={`/app/utenti/edit/${c.idUtente}`}><strong>{c.username}</strong></Link>;
        }

        return (
            <tr>
                <td className="collapsing">{c.idUtente}</td>
                <td className="sorted descending">{lnkUsername}</td>
                <td className="collapsing">{c.nome}</td>
                <td className="center aligned"><SiNoTableColumn value={c.roleAdmin}/></td>
                <td className="center aligned"><SiNoTableColumn value={c.attivo}/></td>
                <td className="collapsing no-print">                   
                    {editBtn}
                    {deleteButton}
                </td>
            </tr>)
    }
}

export default UtentiTableRow;




/** WEBPACK FOOTER **
 ** ./src/components/utenti/UtentiTableRow.js
 **/